module.exports = __webpack_public_path__ + "img/search-spis-icon.96e75f62.svg";